import { PureComponent } from 'react'
import { Tooltip as Tippy } from 'react-tippy'
import { $ } from 'utils'

export default class Tooltip extends PureComponent {

  render() {
    const children = this.props.children
    const { tip, position = 'right' } = this.props

    return (
      $(Tippy, {
          title: tip,
          position,
          arrow: true,
          arrowSize: 'small',
        },
        children
      )
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Tooltip.js